import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = props => {
  const {
    className,
    id,
    disabled,
    text,
    selected,
    linkProps,
    onClick,
    isFilled,
  } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });
  const dotClasses = classNames(css.dot, {
    [css.selectedDot]: selected,
    [css.filledDot]: isFilled,
  });

  const content = linkProps ? (
    <NamedLink className={linkClasses} {...linkProps}>
      {text}
    </NamedLink>
  ) : (
    <button
      className={linkClasses}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {text}
    </button>
  );

  return (
    <div id={id} className={classNames(css.tab, className)}>
      <div className={dotClasses}></div>
      {content}
    </div>
  );
};

Tab.defaultProps = {
  className: null,
  disabled: false,
  selected: false,
  isFilled: false,
  linkProps: null,
  onClick: null,
};

const { arrayOf, bool, func, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object,
  onClick: func,
  isFilled: bool,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  const containerRef = useRef(null);
  // const [lineHeight, setLineHeight] = useState('0px');

  // useEffect(() => {
  //   if (containerRef.current) {
  //     const containerHeight = containerRef.current.scrollHeight;
  //     // setLineHeight(`${containerHeight}px`);
  //     setLineHeight('100%');
  //   }
  // }, [tabs]);

  // Find the index of the selected tab
  const selectedIndex = tabs.findIndex(tab => tab.selected);

  // Calculate the percentage to fill the progress bar
  const fillPercentage =
    selectedIndex >= 0 ? (selectedIndex / (tabs.length - 1)) * 100 : 0;

  useEffect(() => {
    if (containerRef.current) {
      const containerHeight = containerRef.current.scrollHeight;
      containerRef.current.style.setProperty(
        '--line-height',
        `${containerHeight}px`
      );
    }
  }, [tabs]);

  return (
    <nav className={classes}>
      <div className={css.progressContainer} ref={containerRef}>
        <div
          className={css.progressLine}
          style={{ '--fill-percentage': `${fillPercentage}%` }}
        ></div>
        {tabs.map((tab, index) => {
          const id = typeof tab.id === 'string' ? tab.id : `${index}`;
          return (
            <Tab
              key={id}
              id={id}
              className={tabClasses}
              isFilled={index <= selectedIndex}
              {...tab}
            />
          );
        })}
      </div>
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(
    PropTypes.shape({
      id: string,
      text: node.isRequired,
      disabled: bool,
      selected: bool,
      linkProps: object,
      onClick: func,
    })
  ).isRequired,
};

export default TabNav;
